import { render, staticRenderFns } from "./amplifyAuthTest.vue?vue&type=template&id=0b29105d&"
import script from "./amplifyAuthTest.vue?vue&type=script&lang=js&"
export * from "./amplifyAuthTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports